//import "bootstrap";
import "../Content/fonts/Segeo/segeoFont.css";
import "./store-state.js";
import "./response-status.js";
import "./helpers/breadcrumbs-helper.js";
import axios from "axios";

//import "../Content/wp-includes/js/jquery/jquery.minf43b.js";
// import "../Content/wp-includes/js/jquery/jquery-migrate.min5589.js";
import "../Content/wp-content/plugins/elementor/assets/lib/font-awesome/js/v4-shims.min87e3.js";

import "../Content/wp-includes/css/tabs.css";

//helpers
import "./utils/casting-utilities.js";
import "./helpers/currency-helper.js";
import "./helpers/array-helper.js";
import "./helpers/roundingValue-helper.js";
import "./helpers/tooltip-helper.js";
import "./helpers/pageTitle-helper.js";
import "./helpers/contentType-helper.js";
import "./helpers/localStorageCache-helper.js";
import "./helpers/httpResponseCode-helper.js";
import "./helpers/apiResponseHandler-helper.js";
import "./helpers/pages/termsAndConditions/tabs-helper.js";
import "./helpers/device-helper.js";

//services
import "./services/test-service.js";
import "./services/system-service.js";
import "./services/settings-service.js";
import "./services/customer-service.js";
import "./services/notification-service.js";
import "./services/competition-service.js";

// css
import "../Content/wp-includes/css/dist/block-library/style.min1e39.css";
import "../Content/wp-includes/css/classicStyles.css";
import "../Content/wp-content/plugins/cleantalk-spam-protect/css/cleantalk-public.min937c.css";
import "../Content/wp-content/themes/hello-elementor/style.min41fe.css";
import "../Content/wp-content/themes/hello-elementor/theme.min41fe.css";
import "../Content/wp-content/themes/hello-elementor/header-footer.min41fe.css";
import "../Content/wp-content/plugins/elementor/assets/lib/eicons/css/elementor-icons.min91ce.css";
import "../Content/wp-content/plugins/elementor/assets/css/frontend-lite.min87e3.css";
import "../Content/wp-includes/css/elementorStyles.css";
import "../Content/wp-content/plugins/elementor-pro/assets/css/frontend-lite.min87e3.css";
import "../Content/wp-content/plugins/elementor/assets/lib/font-awesome/css/all.min87e3.css";
import "../Content/wp-content/plugins/elementor/assets/lib/font-awesome/css/v4-shims.min87e3.css";
import "../Content/wp-content/plugins/elementor/assets/css/widget-icon-list.min.css";
import "../Content/wp-includes/css/style.css";

//vue plugins
import { createRouter, createWebHashHistory } from "vue-router";

window.axios = axios;

import VueDatePicker from '@vuepic/vue-datepicker';
import '../Content/vueDatepicker/main.css';

import TestComponent from "./components/test/test.vue";
import CustomerSignUp from "./components/customerSignUp/CustomerSignUp.vue";
import NameAndMobileNumberForm from "./components/customerSignUp/common/nameAndMobileNumberForm/NameAndMobileNumberForm.vue";
import OtpForm from "./components/customerSignUp/common/otpForm/OtpForm.vue";
import SignUpSuccess from "./components/customerSignUp/common/signUpSuccess/SignUpSuccess.vue";
import CustomerDetailsForm from "./components/customerSignUp/common/customerDetailsForm/CustomerDetailsForm.vue";
import LogQuery from "./components/logQuery/LogQuery.vue";
import CompetitionSubmissionForm from "./components/CompetitionSubmissionForm/CompetitionSubmissionForm.vue";

import Dropdown from "./components/controls/dropdown/Dropdown.vue";

import {createApp} from "vue";

let options = {
    data() {
        return {
            sharedState: storeState.state,
            breadcrumbs: [],
            maxBreadcrumbs: 3,
            breadcrumbsSessionKey: "breadcrumbs",
            isRefreshed: true,
            breadcrumbState: breadcrumbsStoreState.breadcrumbsState,
            //hideTitleBar: false,
            welcomePageReplacedInNavigationHistory: false,
            shouldReplaceUrl: true
        };
    },
    methods: {
        navigateToNewRoot(route){
            if(!this.welcomePageReplacedInNavigationHistory){
                this.$router.replace(route);
                this.welcomePageReplacedInNavigationHistory = true;
            }
            else{
                this.$router.push(route);
            }
        },
        determineIfMenuItemsShouldReplaceUrl(){
            if(window.location.hash === "#/"){
                this.shouldReplaceUrl = true;
            }
            else{
                this.shouldReplaceUrl = false;
            }
        }
    },
    components: {
    },
    mounted: function () {
        //this.loadBreadcrumbs();
        breadcrumbsStoreState.loadBreadcrumbs();
    },
    watch: {
        // '$route':{
        //     handler: function(){
        //         // if(this.$route.meta.hideTitleBar){
        //         //     this.hideTitleBar = true;
        //         // }
        //         // else{
        //         //     this.hideTitleBar = false;
        //         // }
        //         this.determineIfMenuItemsShouldReplaceUrl();
        //     },
        //     immediate: true,
        //     deep: true
        // },
        breadcrumbState:{
            handler: function(){
                this.breadcrumbs = breadcrumbsStoreState.getBreadcrumbsToDisplay();
            },
            immediate: true,
            deep: true
        }
    }
};

const app = createApp(options);
app.component("dropdown", Dropdown);
app.component("VueDatePicker", VueDatePicker);

app.component("customer-sign-up", CustomerSignUp);
app.component("name-and-mobile-number-form", NameAndMobileNumberForm);
app.component("otp-form", OtpForm);
app.component("sign-up-success", SignUpSuccess);
app.component("customer-details-form", CustomerDetailsForm);
app.component("log-query", LogQuery);
app.component("competition-submission-form", CompetitionSubmissionForm);

//global filters
app.config.globalProperties.$filters = {
    dateShortForm(date, showTime) {
        if(showTime){
            return moment(date).format("DD MMM YYYY HH:mm");
        }
        return moment(date).format("DD MMM YYYY");
    }
};

if (document.getElementById("spa-page")){
    // TODO: add routes here
    const routes = [
        {
            path: "/", 
            component: TestComponent 
        }
    ];
    const router = createRouter({
        history: createWebHashHistory(),
        //history: createWebHistory('Portal/Home'),
        routes, // short for `routes: routes`
    });
    app.use(router);
}

if (document.getElementById("app")) {
    //load vue js options on specific pages
    app.mount('#app');
}